import type { Sender } from "../../../../List/components/CampaignOverview/components/Sender";

/**
 * A sender is considered "set" for the prospect/campaign when at least one sender is active.
 *
 * Used both to gate scheduling (no active sender → nothing to send from, so saving is disabled)
 * and to decide whether the "configure who is sending" section in the schedule-confirm modal
 * should open expanded by default.
 */
export const hasActiveSender = (senders: Sender[]): boolean =>
	senders.some((sender) => sender.active);
